import type { ReactNode } from 'react'

/** Standard page body: artboard 01 main column (32px / 40px padding, 24px gap). */
export function Page({ children }: { children: ReactNode }) {
  return <div className="flex min-w-0 flex-col gap-6 px-10 py-8">{children}</div>
}
